<template>
    <div>
        <sub-menu-faturamento ativo="visao"></sub-menu-faturamento>

        <div class="card dashcard mb-0"> <!-- cabecalho-parm-fixo  -->
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input 
                            icon="fa fa-calendar-o fa-fw"
                            type="select"
                            placeholder="Produção"
                            :optionsList="[
                                { id: 'f', search: 'Emissão da Fatura' },
                                { id: 'e', search: 'Envio da Fatura' },
                                { id: 'v', search: 'Vencimento da Fatura' },
                            ]"
                            optionsDisplay="search"
                            optionsData="id"
                            v-model="filtros.referencia">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            :edicao="!$store.state.user.id_unidade_operacao"
                            icon="fa fa-building"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-concierge-bell"
                            type="select"
                            placeholder="Todas as Recepções..."
                            :optionsList="lista_recepcoes"
                            optionsData="id_recepcao"
                            :edicao="filtros.id_unidade_operacao > 0"
                            v-model="filtros.id_recepcao" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-credit-card"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            optionsName="operados.fatura.classe.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: true,
                                lista: true
                            }"
                            service="operadoras.index"
                            placeholder="Operadoras..."
                            v-model="filtros.id_operadora">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-contract"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_contrato_operadora"
                            optionsDisplay="search"
                            service="contrato_operadoras.index"
                            :optionsParm="{ id_operadora: filtros.id_operadora, guias: true }"
                            optionsName="contratos-busca-guia"
                            placeholder="Contrato..."
                            :edicao="filtros.id_operadora ? true : false"
                            v-model="filtros.id_contrato_operadora">
                        </az-input>
                    </div>   
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-powerpoint"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_plano"
                            optionsDisplay="st_plano"
                            service="planos.index"
                            :optionsParm="{ id_operadora: filtros.id_operadora }"
                            :edicao="filtros.id_operadora ? true : false"
                            optionsName="planos"
                            placeholder="Plano..."
                            v-model="filtros.id_plano">
                        </az-input>
                    </div>                 
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="select"
                            placeholder="Tipo de Contrato..."
                            icon="fa fa-filter"
                            :hli="true"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'PJ', search: 'Contratos PJ' },
                                { id: 'PF', search: 'Contratos PF' },
                                { id: 'SC', search: 'Sem Contrato' },
                            ]" 
                            optionsData="id"
                            v-model="filtros.tipo_contrato" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <div class="d-flex flex-column">
                            <az-input   
                                type="button-group"
                                :optionsList="[
                                    { id: 'R', search: 'Resumido' }, 
                                    { id: 'D', search: 'Detalhado' }, 
                                ]"
                                v-model="filtros.tipovisao">
                                <template v-slot:buttonposbg>
                                    <print-export printid="guias-operadora" :left="true" class="ml-2" />
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div id="guias-operadora">

            <cabecalho-generico titulo="Faturamento - Visão Geral">
                <div v-if="false">Período: {{ $util.getFormatDate(visao.inicio) }} a {{ $util.getFormatDate(visao.fim) }}</div>
                <div v-if="visao && visao.parms && visao.parms.referencia">
                    {{ visao.parms.referencia == 'f' 
                        ? 'Emissão da Fatura' 
                        : ( visao.parms.referencia == 'f' ? 'Envio da Fatura' : 
                            ( visao.parms.referencia == 'v' ? 'Vencimento da Fatura' : '' ) ) }}
                </div>
                <div v-if="visao && visao.parms && visao.parms.uo && visao.parms.uo.st_nome">{{ visao.parms.uo.st_nome }}</div>
                <div v-if="visao && visao.parms && visao.parms.recep && visao.parms.recep.st_nome">{{ visao.parms.recep.st_nome }}</div>
                <div v-if="visao && visao.parms && visao.parms.tipo_contrato">
                    Contratos {{ visao.parms.tipo_contrato }}
                </div>
                <div v-if="visao && visao.parms && visao.parms.operadora">
                    {{ visao.parms.operadora.st_operadora }}
                </div>
                <div v-if="visao && visao.parms && visao.parms.contrato">
                    {{ visao.parms.contrato }}
                </div>
            </cabecalho-generico>

            <!-- GUIAS -->
            <div class="card dashcard mb-3">
                <div class="card-header bg-dark text-white d-flex justify-content-between">
                    <div>Total</div>
                    <div v-if="visao">
                        {{ $util.getFormatDate(visao.inicio) }} a {{ $util.getFormatDate(visao.fim) }}
                    </div>
                    <div>{{ getValorTotalGuias() }}</div>
                </div>
            </div>

            <div class="card-deck mb-3">

                <!-- Disponível -->
                <card-valor 
                    title="Recepção"
                    :titlecenter="percentual(['DI', 'PR','PT', 'TS'])"
                    :titleright="getValorTotalByStatus (['DI', 'PR','PT', 'TS'])"
                    :callback="detalharStatus"
                    :lista="[
                        { title: 'Disponível', status: 'DI', valor: getValorByStatus ('DI'), guias: getGuiasByStatus('DI'), criacao: getDataByStatus('DI') },
                        { title: 'Pendente', status: 'PR', valor: getValorByStatus ('PR'), guias: getGuiasByStatus('PR'), criacao: getDataByStatus('PR'), class: 'text-danger' },
                        { title: 'Protocolada', status: 'PT', valor: getValorByStatus ('PT'), guias: getGuiasByStatus('PT'), criacao: getDataByStatus('PT'), class: 'text-dark' },
                        { title: 'Tratamento Seriado', status: 'TS', valor: getValorByStatus ('TS'), guias: getGuiasByStatus('TS'), criacao: getDataByStatus('TS'), class: 'text-warning', optional: true },
                        { title: 'Canceladas', status: 'CA', valor: getValorByStatus ('CA'), guias: getGuiasByStatus('CA'), criacao: getDataByStatus('CA'), class: 'text-muted' }]"
                    header="bg-success text-white">
                </card-valor>

                <!-- A Faturar -->
                <card-valor 
                    title="Faturamento"
                    :titlecenter="percentual(['AF', 'PE','EF', 'PF'])"
                    :titleright="getValorTotalByStatus (['AF', 'PE', 'EF', 'PF'])"
                    :callback="detalharStatus"
                    :lista="[
                        { title: 'A Faturar', status: 'AF', valor: getValorByStatus ('AF'), guias: getGuiasByStatus('AF'), criacao: getDataByStatus('AF') },
                        { title: 'Protocolo Fatura', status: 'PF', valor: getValorByStatus ('PF'), guias: getGuiasByStatus('PF'), criacao: getDataByStatus('PF'), optional: true },
                        { title: 'Pendente', status: 'PE', valor: getValorByStatus ('PE'), guias: getGuiasByStatus('PE'), criacao: getDataByStatus('PE'), class: 'text-danger' },
                        { title: 'Em Fatura', status: 'EF', valor: getValorByStatus ('EF'), guias: getGuiasByStatus('EF'), criacao: getDataByStatus('EF'), class: 'text-primary' }
                    ]"
                    header="bg-info text-white">
                </card-valor>

                <!-- Faturadas -->
                <card-valor 
                    title="Faturadas"
                    :titlecenter="percentual(['FT', 'RC', 'RP', 'GT', 'GP'])"
                    :titleright="getValorTotalByStatus (['FT', 'RC', 'RP', 'GT', 'GP'])"
                    :callback="detalharStatus"
                    :lista="[
                        { title: 'Enviada', status: 'FT', valor: getValorByStatus ('FT'), guias: getGuiasByStatus('FT'), criacao: getDataByStatus('FT') },
                        { title: 'Recebido', status: 'R', valor: getValorByStatus ('R', true, true), guias: getGuiasByStatus('R'), criacao: '', class: 'text-success', optional: true },
                        { title: 'Glosado', status: 'G', valor: getValorByStatus ('G', true, true), guias: getGuiasByStatus('G'), criacao: '', class: 'text-danger', optional: true },
                        { title: 'A Receber', status: 'A', valor: getValorByStatus ('A', true, true), guias: getGuiasByStatus('A'), criacao: '', class: 'text-secondary', optional: true },
                    ]"
                    header="bg-primary text-white">
                </card-valor>

            </div>

            <div class="card dashcard mb-3">
                
                <table class="table table-sm table-hover bg-white small mb-0 cabecalho-fixo">
                    <thead>
                        <tr>
                            <th>Operadora</th>
                            <th class="text-right table-success">Disponível</th>
                            <th class="text-right table-success">Pendente</th>
                            <th class="text-right table-success">Protocolada</th>
                            <th class="text-right table-success">Trat. Seriado</th>

                            <th class="text-right table-info">A Faturar</th>
                            <th class="text-right table-info">Prot. Fatura</th>
                            <th class="text-right table-info">Pendente</th>
                            <th class="text-right table-info">Em Fatura</th>

                            <th class="text-right table-primary">Enviada</th>
                            <th class="text-right table-primary">Recebida</th>
                            <th class="text-right table-primary">Glosada</th>

                            <th class="text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(oper, iox) in lista_operadoras_guias" :key="iox">
                            <td>{{ oper }}</td>
                            <td class="text-right">{{ getValorByStatus ('DI', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('PR', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('PT', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('TS', true, false, oper) }}</td>

                            <td class="text-right">{{ getValorByStatus ('AF', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('PF', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('PE', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('EF', true, false, oper) }}</td>

                            <td class="text-right">{{ getValorByStatus ('FT', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('R', true, false, oper) }}</td>
                            <td class="text-right">{{ getValorByStatus ('G', true, false, oper) }}</td>

                            <td class="text-right">{{ getValorTotalGuias(true, oper) }}</td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <th>Total</th>
                            <th class="text-right">{{ getValorByStatus ('DI', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('PR', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('PT', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('TS', true, false) }}</th>

                            <th class="text-right">{{ getValorByStatus ('AF', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('PF', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('PE', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('EF', true, false) }}</th>

                            <th class="text-right">{{ getValorByStatus ('FT', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('R', true, false) }}</th>
                            <th class="text-right">{{ getValorByStatus ('G', true, false) }}</th>

                            <th class="text-right">{{ getValorTotalGuias(true) }}</th>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </div>

        <template v-if="filtros.tipovisao == 'D'">

            <!-- PENDÊNCIAS e GLOSAS -->
            <az-break-title title="Pendências e Glosas" />
            <div class="card-deck mb-3">

                <card-valor title="Pendências Recepção" valor="" header="bg-danger text-white">

                    <p class="lead" v-if="pendenciasRecepcao && !pendenciasRecepcao.length">
                        Nenhuma pendência identificada.
                    </p>

                    <table class="table table-sm" v-else>
                        <tbody>
                            <tr v-for="(guia, index) in pendenciasRecepcao" :key="index">
                                <td>
                                    <small>
                                        <a href="#" @click.prevent="editar(guia)" class="card-link">
                                            {{ guia.guia_formatada }}
                                        </a>
                                    </small>
                                </td>
                                <td><small>{{ guia.motivo_glosa.search }}</small></td>
                                <td><small class="text-danger text-nowrap">{{ getHumanDuration(guia.dt_criacao) }}</small></td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                                <td colspan="3">
                                    <small class="mt-3">
                                        <router-link :to="{ name: 'guias', params: { status: 'PR', ...filtros } }">
                                            Listar Todas
                                        </router-link>
                                    </small>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                </card-valor>

                <card-valor title="Pendências Internas" valor="" header="bg-danger text-white">

                    <p class="lead" v-if="pendenciasInternas && !pendenciasInternas.length">
                        Nenhuma pendência identificada.
                    </p>

                    <table class="table table-sm" v-else>
                        <tbody>
                            <tr v-for="(guia, index) in pendenciasInternas" :key="index">
                                <td>
                                    <small>
                                        <a href="#" @click.prevent="editar(guia)" class="card-link">
                                            {{ guia.guia_formatada }}
                                        </a>
                                    </small>
                                </td>
                                <td><small>{{ guia.motivo_glosa.search }}</small></td>
                                <td><small class="text-danger text-nowrap">{{ getHumanDuration(guia.dt_criacao) }}</small></td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                                <td colspan="3">
                                    <small class="mt-3">
                                        <router-link :to="{ name: 'guias', params: { status: 'PE', ...filtros } }">
                                            Listar Todas
                                        </router-link>
                                    </small>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                </card-valor>

                <card-valor title="Motivos de Glosas (Top 5)" valor="" header="bg-danger text-white" link="">

                    <p class="lead" v-if="visao && visao.glosas && !visao.glosas.length">
                        Nenhuma glosa identificada.
                    </p>
                    
                    <table class="table table-sm" v-else-if="visao && visao.glosas && visao.glosas.length">
                        <tbody>
                            <tr v-for="(motivo, index) in visao.glosas" :key="index">
                                <td>
                                    <small>
                                        {{ motivo.st_descricao }}
                                    </small>
                                </td>
                                <td class="text-right">
                                    <small>
                                        {{ $util.formatMoeda(motivo.valor) }}
                                    </small>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </card-valor>

            </div>

            <!-- Faturamento -->
            <az-break-title title="Faturamento" />
            <div class="card-deck mb-3">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Movimento Mensal (Produzido)
                    </div>
                    <div class="card-body text-right">
                        <div v-if="guias">
                            <Chart 
                                :type="mensal().labels.length <= 1 ? 'bar' : 'line'" 
                                :data="mensal ()" 
                                :options="{ 
                                    legend: { display: false },
                                    scales: {
                                        yAxes: [{
                                            ticks: {
                                                callback: function(value, index, values) {
                                                    return formatMoedaGrafico(value);
                                                }
                                            }
                                        }],
                                    }
                                }"/>
                        </div>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Atendimentos Por Operadora
                    </div>
                    <div class="card-body text-right">
                        <div v-if="guias">
                            <Chart type="horizontalBar" :data="operadora ()" 
                            :options="{
                                legend: { display: false },
                                scales: {
                                    yAxes: [{
                                        barThickness: 24,  // number (pixels) or 'flex'
                                        maxBarThickness: 32, // number (pixels)
                                    }],
                                    xAxes: [{
                                        ticks: {
                                            callback: function(value, index, values) {
                                                return formatMoedaGrafico(value);
                                            }
                                        }
                                    }]
                                },
                            }" />
                        </div>
                    </div>
                </div>

            </div>

            <div class="card-deck mb-3">

                <div class="card card-dash dashcard" style="padding: 0px;" v-if="false">
                    <div class="card-header bg-primary text-white">
                        Resumo por Mês
                    </div>
                    <div class="card-body">
                        <table class="table table-responsive-md small" v-if="visao && visao.resumo_mes">
                            <thead>
                                <tr>
                                    <th>Mês</th>
                                    <th class="text-right">Produzido</th>
                                    <th class="text-right">Faturado</th>
                                    <th class="text-right">Glosado</th>
                                    <th class="text-right">Recebido</th>
                                    <th class="text-right text-nowrap">A Receber</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(mes, imes) in visao.resumo_mes" :key="imes">
                                    <td>{{ $util.getFormatDate (mes.mes, 'MMM/YY').toUpperCase() }}</td>
                                    <td class="text-right">{{ $util.formatMoeda (mes.produzido) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda (mes.valor) }}</td>
                                    <td class="text-danger text-right">{{ $util.formatMoeda (mes.glosado) }}</td>
                                    <td class="text-primary text-right">{{ $util.formatMoeda (mes.recebido) }}</td>
                                    <td class="text-success text-right">{{ $util.formatMoeda (mes.a_receber) }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <pre v-if="1 == 0">{{ mensalTabela }}</pre>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Composição do Faturamento (Envio)
                    </div>
                    <div class="card-body">
                        <p v-if="visao && visao.mes_composicao">Faturado em: {{ $util.getFormatDate(visao.mes_composicao, 'MMM/YY').toUpperCase() }}</p>
                        <table class="table table-responsive-md table-hover small" v-if="visao && visao.composicao">
                            <thead>
                                <tr>
                                    <th>Atendido</th>
                                    <th class="text-right">Guias</th>
                                    <th class="text-right">Valor</th>
                                    <th class="text-right">%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(mes, imes) in visao.composicao" :key="imes">
                                    <td>{{ $util.getFormatDate (mes.mes, 'MMM/YY').toUpperCase() }}</td>
                                    <td class="text-right">{{ mes.guias }}</td>
                                    <td class="text-right">{{ $util.formatMoeda (mes.valor) }}</td>
                                    <td class="text-success text-right">{{ $util.formatMoeda ((mes.valor / total_composicao) * 100) }}</td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <th></th>
                                    <th class="text-right">{{ $util.formatMoeda (total_composicao) }}</th>
                                    <th class="text-right text-success">100%</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <div class="card-deck mb-3">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Performance do Faturamento
                    </div>
                    <div class="card-body text-right">
                        <div v-if="guias">
                            <Chart type="bar" :data="performance ()" 
                            :options="{ 
                                scales: { 
                                    xAxes: [{ 
                                        stacked: true, 
                                        barThickness: 32, 
                                        maxBarThickness: 48,
                                    }], 
                                    yAxes: [{ 
                                        stacked: true,
                                        ticks: {
                                            callback: function(value, index, values) {
                                                return formatMoedaGrafico(value);
                                            }
                                        }
                                    }] 
                                } 
                            }" />
                        </div>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        <span>
                            Performance por Operadora
                        </span>
                    </div>
                    <div class="card-body text-right">
                        <div v-if="guias">
                            <Chart type="horizontalBar" :data="performance_operadora ()" 
                            :options="{ 
                                scales: { 
                                    yAxes: [{ 
                                        stacked: true, 
                                        barThickness: 18, 
                                        maxBarThickness: 24,
                                    }], 
                                    xAxes: [{ 
                                        stacked: true,
                                        ticks: {
                                            callback: function(value, index, values) {
                                                return formatMoedaGrafico(value);
                                            }
                                        }
                                    }] 
                                } 
                            }" />
                        </div>
                    </div>
                </div>

            </div>

            <div class="card-deck mb-3">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Ticket Médio
                    </div>
                    <div class="card-body">
                        <table class="table table-hover" v-if="visao">
                            <tbody>
                                <tr v-for="(ticket, itx) in visao.ticket_medio" :key="itx">
                                    <td>{{ ticket.st_operadora }}</td>
                                    <td class="text-right">{{ $util.formatMoeda (ticket.ticket_medio) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Prazo Médio de Recebimento (em dias)
                    </div>
                    <div class="card-body">
                        <table class="table table-hover" v-if="visao">
                            <thead>
                                <tr>
                                    <th>Operadora</th>
                                    <th class="text-right">Contra Atendimento</th>
                                    <th class="text-right">Contra Envio</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(prazo, ipx) in visao.prazo_recebimento" :key="ipx">
                                    <td>{{ prazo.st_operadora }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(prazo.prazo_contra_atendimento) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(prazo.prazo_contra_envio) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

        </template>

        <!-- Detalhes -->

        <button v-if="1 == 0" class="btn btn-primary" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            Detalhes...
        </button>

        <div class="collapse" id="collapseExample">
            <div class="card card-body">
                <pre class="alert alert-primary">{{ agrupadas }}</pre>
                <hr>
                <pre class="alert alert-primary">{{ operadora }}</pre>
                <hr>
                <pre class="alert alert-warning">{{ guias }}</pre>
            </div>
        </div>

        <pre v-if="1 == 0 && visao">{{ visao.performance }}</pre>

        <guia-edicao ref="edicao" @refresh="load (false)"></guia-edicao>

        <!-- Modal -->
        <div class="modal fade" id="drillDownModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="drillDownTable">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span class="badge badge-secondary mr-2">{{ drillDownStatus }}</span>
                            Por Operadora
                        </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Operadora</th>
                                    <th>Mais antiga</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-right">Guias</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(linha, ilx) in drillDownTable" :key="ilx">
                                    <td>{{ linha.st_operadora }}</td>
                                    <td>
                                        <div>{{ $util.getFormatDate(linha.dt_guia_criacao_1) }}</div>
                                        <div class="small text-muted">{{ getHumanDuration (linha.dt_guia_criacao_1) }}</div>
                                    </td>
                                    <td class="text-right">
                                        <div>{{ $util.formatMoeda( valorOperadoraStatus(linha, drillDownStatus) ) }}</div>
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar" role="progressbar" 
                                                :style="'width: ' + calcPercentual(valorOperadoraStatus(linha, drillDownStatus), getValorByStatus(drillDownStatus, false)) + '%;'">
                                                {{ $util.formatMoeda(calcPercentual(valorOperadoraStatus(linha, drillDownStatus), getValorByStatus(drillDownStatus, false))) }}%
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-right">{{ linha.guias }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Total</th>
                                    <th></th>
                                    <th class="text-right">{{ getValorByStatus(drillDownStatus) }}</th>
                                    <th class="text-right"></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-primary" @click="listarFaturas()" v-if="drillDownStatus == 'EF'">Faturas</button>
                        <button type="button" class="btn btn-primary" @click="listar(drillDownStatus)">Listar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import * as moment from 'moment';
import _ from 'lodash';
import $ from 'jquery';
import CardValor from './CardValor.vue';
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import GuiaEdicao from './GuiaEdicao.vue';
import AzBreakTitle from '../../util/AzBreakTitle';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data () { 
        return {
            guias: null,
            visao: null, 
            drillDownTable: [],
            drillDownStatus: "", 
            filtros: { 
                mes: "",
                id_operadora: "", 
                id_plano: "", 
                id_contrato_operadora: "", 
                id_recepcao: "", 
                inicio: "",
                fim: "", 
                id_unidade_operacao: "", 
                periodo: "m",
                referencia: "", 
                tipovisao: "R", 
                tipo_contrato: "", 
            },
            firstLoad: false, 
            canceltoken: null, 
            motivoGlosas: [],
        }
    },
    components: { 
        SubMenuFaturamento,
        CardValor,
        GuiaEdicao,
        AzBreakTitle,
        AzInput,
        AzPeriodo, 
        PrintExport,
        CabecalhoGenerico, 
    },
    computed: { 
        glosasLista: function () { 

            if ( !this.guias )
                return [];

            let lista = _.take(
                _.flatMap( 
                    _.orderBy(this.guias.filter(item => ( item.ch_status == 'GP' || item.ch_status == 'GT' )), ['dt_criacao'], ['asc']),
                    (item) => { 
                        let pend = item.guia_motivo_glosa_pendentes.map(pendencia => { 
                            return { ...pendencia, ...item };
                        });
                        return pend;
                    })
                , 5);

            return _.groupBy(lista, item => item.motivo_glosa.search);

        },

        pendenciasRecepcao: function () { 

            if ( !this.guias )
                return [];

            let lista = _.take(
                _.orderBy( 
                    _.flatMap(this.guias.filter(item => ( item.ch_status == 'PR' )),
                    (item) => { 
                        let dtc = item.dt_criacao;
                        let pend = item.guia_motivo_glosa_pendentes.map(pendencia => { 
                            return { ...pendencia, ...item };
                        });

                        pend.dt_criacao = dtc;
                        return pend;
                    })
                    , ['dt_criacao'], ['asc']
                )
                , 5);

            return lista;

        },

        pendenciasInternas: function () { 

            if ( !this.guias )
                return [];

            let lista = _.take(
                _.orderBy( 
                    _.flatMap(this.guias.filter(item => ( item.ch_status == 'PE' )),
                    (item) => { 
                        let dtc = item.dt_criacao;
                        let pend = item.guia_motivo_glosa_pendentes.map(pendencia => { 
                            return { ...pendencia, ...item };
                        });

                        pend.dt_criacao = dtc;
                        return pend;
                    })
                    , ['dt_criacao'], ['asc']
                )
                , 5);
            
            return lista;

        },

        agrupadas: function () { 
            let grp = _.groupBy(this.guias, function (item) { 
                return item.ch_status;
            });

            return _.mapValues(grp, function (items) { 
                return _.sumBy(items, function(item) { 
                    return _.sumBy(item.atendimento_procedimento_guias, function (pg) { 
                        return pg.dc_valor ? parseFloat(pg.dc_valor) : 0;
                    });  
                });
            });
        },
        
        mensalTabela: function () { 
            let grp = _.groupBy(this.guias, function (item) { 
                return item.dt_criacao.substr(0,7);
            });

            return grp;

        },

        total_composicao: function () { 

            if ( !this.visao || !this.visao.composicao )
                return null;

            return this.visao.composicao.reduce((total, item) => { 
                    return total + ( item.valor ? parseFloat(item.valor) : 0 );
                }, 0);

        },

        lista_recepcoes: function () { 
            if ( !this.filtros.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.filtros.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        lista_operadoras_guias: function () { 
            if ( !this.visao || !this.visao.situacao ) { 
                return [];
            }

            return _.uniq(this.visao.situacao.map(item => item.st_operadora)).sort();
        }

    },

    watch: { 
        filtros: {
            handler: function () {
                if ( this.firstLoad ) { 
                    //this.visao = null;
                    //this.$store.commit('loading', true);
                    //this.load ();
                }
            },
            deep: true,
            immediate: true
        },
    },

    methods: { 
        valorOperadoraStatus (linha, status) { 
            switch (status) {
                case 'G': return linha.glosado;
                case 'R': return linha.recebido;
                case 'A': return linha.a_receber;
                default: return linha.valor;
            }
        },

        formatMoedaGrafico(value) { 
            let show = this.$util.formatMoeda(value);
            return show.substr(0,show.length - 3);
        },

        performance_operadora() { 
            if ( !this.visao )
                return [];

            let valores = _.orderBy(this.visao.performance_operadora, 'st_operadora', 'asc');

            let grupos = _.groupBy(valores, 'st_operadora');
            let labels = _.keys(grupos);

            let grafico = { 
                labels: labels,
                datasets: [
					{
						label: 'Faturado',
                        backgroundColor: '#33CC11',
                        borderColor: '#33CC11',
                        fill: false, 
                        data: labels.map(oper => { 
                                return this.visao.performance_operadora.filter(item => item.situacao == 'Faturado' &&  item.st_operadora == oper)
                                    .reduce((total, item) => { 
                                        return total + ( item.valor_grupo ? parseFloat(item.valor_grupo) : 0 );
                                    }, 0);
                            })
                    },
                    {
						label: 'A Faturar',
                        backgroundColor: '#42A5F5',
                        borderColor: '#42A5F5',
                        fill: false, 
						data: labels.map(oper => { 
                                return this.visao.performance_operadora.filter(item => item.situacao == 'A Faturar' &&  item.st_operadora == oper)
                                    .reduce((total, item) => { 
                                        return total + ( item.valor_grupo ? parseFloat(item.valor_grupo) : 0 );
                                    }, 0);
                            })
					},
                    {
						label: 'A Realizar',
                        backgroundColor: '#3311CC',
                        borderColor: '#3311CC',
                        fill: false, 
						data: labels.map(oper => { 
                                return this.visao.performance_operadora.filter(item => item.situacao == 'A Realizar' &&  item.st_operadora == oper)
                                    .reduce((total, item) => { 
                                        return total + ( item.valor_grupo ? parseFloat(item.valor_grupo) : 0 );
                                    }, 0);
                            })
					}
                ],
            };

            return grafico;


        },

        performance () { 
            if ( !this.visao )
                return [];

            let valores = _.orderBy(this.visao.performance, 'mes', 'asc');

            let grupos = _.groupBy(valores, 'mes');
            let labels = _.keys(grupos);

            let grafico = { 
                labels: labels.map(mes => this.$util.getFormatDate(mes, 'MMM').toUpperCase ()),
                datasets: [
					{
						label: 'Faturado no mês',
                        backgroundColor: '#33CC11',
                        borderColor: '#33CC11',
                        fill: false, 
                        data: labels.map(mes => { 
                                return this.visao.performance.filter(item => item.faturado_em == 'M' &&  item.mes == mes)
                                    .reduce((total, item) => { 
                                        return total + ( item.valor ? parseFloat(item.valor) : 0 );
                                    }, 0);
                            })
                    },
                    {
						label: 'Faturado fora do mês',
                        backgroundColor: '#42A5F5',
                        borderColor: '#42A5F5',
                        fill: false, 
						data: labels.map(mes => { 
                                return this.visao.performance.filter(item => item.faturado_em == 'F' &&  item.mes == mes)
                                    .reduce((total, item) => { 
                                        return total + ( item.valor ? parseFloat(item.valor) : 0 );
                                    }, 0);
                            })
					},
                    {
						label: 'Não faturado',
                        backgroundColor: '#3311CC',
                        borderColor: '#3311CC',
                        fill: false, 
						data: labels.map(mes => { 
                                return this.visao.performance.filter(item => item.faturado_em == 'N' &&  item.mes == mes)
                                    .reduce((total, item) => { 
                                        return total + ( item.valor ? parseFloat(item.valor) : 0 );
                                    }, 0);
                            })
					}
                ],
            };

            return grafico;

        },

        mensal () { 
            if ( !this.visao )
                return { labels: [] };

            let valores = this.visao.movimento.map(item => { 
                return { 
                    label: item.mes,
                    value: item.valor, 
                }
            })

            valores = _.orderBy(valores, 'label', 'asc');

            let grafico = {
				labels: _.map(valores, (item) => { 
                    return this.$util.getFormatDate(item.label, 'MMM/YY').toUpperCase();
                }),
				datasets: [
					{
						label: 'Total',
                        backgroundColor: 'rgba(0,255,0,0.1)',
                        borderColor: '#33CC11',
                        fill: true, 
						data: _.map(valores, (item) => { 
                                return item.value;
                            })
					}
				]
            };
            
            return grafico;

        },

        operadora () { 
            if ( !this.visao )
                return [];

            let valores = _.cloneDeep(this.visao.operadora);

            valores = valores.map(item => { 
                    return { 
                        label: item.st_operadora,
                        value: item.valor, 
                    }
                });

            valores = _.orderBy(valores, 'value', 'desc');

            if ( valores.length > 10 ) { 
                valores[10].label = 'OUTROS';
                valores[10].value = _.sumBy(valores.slice(10,valores.length), "value");
                valores = valores.slice(0,11);
            }

            let graficoOperadora = {
				labels: _.clone(
                    _.map(valores, (item) => { 
                        return item.label;
                    })
                ),
				datasets: [
					{
						label: 'Total',
						backgroundColor: '#42A5F5',
                        data: valores.map(item => item.value)
					}
				]
            };
            
            return graficoOperadora;
        },

        listar(status) {
            $('.modal').modal('hide');
            this.$router.push({ 
                name: "guias", 
                params: { 
                    status: status, 
                    ...this.filtros,
                    buscar: true, 
                } 
            });
        },
        listarFaturas() { 
            $('.modal').modal('hide');
            this.$router.push({ 
                name: "faturas", 
                params: { 
                    ...this.filtros,
                    origem: 'visao', 
                } 
            });
        },
        calcPercentual (valor, total) { 
            if ( total ) { 
                return (valor / total) * 100;
            }

            return 0;
        },

        detalharStatus (status) { 
            this.drillDownStatus = status;
            let dados = _.cloneDeep(this.visao.situacao);

            if ( status == 'A' ) { 
                this.drillDownTable = _.reverse(_.sortBy(dados.filter(item => item.ch_status == 'RP' || item.ch_status == 'GP' ), (item) => item.valor ? parseFloat(item.a_receber) : 0 ));    
            } else if ( status == 'R' ) { 
                this.drillDownTable = _.reverse(_.sortBy(dados.filter(item => item.ch_status == 'RC' || item.ch_status == 'RP' || item.ch_status == 'GP' ), (item) => item.valor ? parseFloat(item.valor) : 0 ));    
            } else if ( status == 'G' ) { 
                this.drillDownTable = _.reverse(_.sortBy(dados.filter(item => item.ch_status == 'GP' || item.ch_status == 'GT' ), (item) => item.valor ? parseFloat(item.valor) : 0 ));    
            } else { 
                this.drillDownTable = _.reverse(_.sortBy(dados.filter(item => item.ch_status == status), (item) => item.valor ? parseFloat(item.valor) : 0 ));
            }

            $('#drillDownModal').modal('show');
        },

        editar (guia) { 
            this.$refs.edicao.abrir(guia);
        },

        getValorTotal (guias, campo = 'total') { 
            return _.sumBy(guias, function (guia) { 
                        return guia.valor_total[campo] ? parseFloat(guia.valor_total[campo]) : 0;
                    });  
        },

        getHumanDuration (date) {  
            let end = moment().startOf('day');
            let base = date.substr (0,10);
            
            if ( base == this.$util.hoje() ) 
                return 'hoje';
            else
                return 'há ' + moment(end, 'YYYY-MM-DD').diff(base, 'days') + ' dia(s)';
                
                //return moment.duration(moment(base, 'YYYY-MM-DD').diff(end)); //.humanize(true);
        },

        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
            });

            return formatter.format(n);
        },

        getValorByStatus (status, formatado = true, optional = false, operadora = null) { 
            if( !this.visao )
                return 0;

            let valor = 0;

            if ( status == 'A' ) { 
                valor = _.sumBy(this.visao.situacao.filter(item => ( item.ch_status == 'GP' || item.ch_status == 'RP' ) && ( !operadora || item.st_operadora == operadora ) ), (item) => { 
                    return item.valor ? parseFloat(item.a_receber) : 0;
                });

            } else if ( status == 'G' ) { 
                valor = _.sumBy(this.visao.situacao.filter(item => ( item.ch_status == 'GP' || item.ch_status == 'GT' ) && ( !operadora || item.st_operadora == operadora ) ), (item) => { 
                    return item.valor ? parseFloat(item.glosado) : 0;
                });

            } else if ( status == 'R' ) { 
                valor = _.sumBy(this.visao.situacao.filter(item => ( item.ch_status == 'GP' || item.ch_status == 'RC' || item.ch_status == 'RP' ) && ( !operadora || item.st_operadora == operadora )), (item) => { 
                    return item.valor ? parseFloat(item.recebido) : 0;
                });

            } else {  
                valor = _.sumBy(this.visao.situacao.filter(item => item.ch_status == status && ( !operadora || item.st_operadora == operadora )), (item) => { 
                    return item.valor ? parseFloat(item.valor) : 0;
                });

            }

            if ( optional && !valor )
                return 0;

            return formatado ? this.$util.formatMoeda ( valor ? valor : '0' ) : ( valor ? valor : '0' );
        },
        getGuiasByStatus (status) { 
            if( !this.visao )
                return 0;

            let valor = 0;

            if ( status == 'A' ) { 
                valor = _.sumBy(this.visao.situacao.filter(item => ( item.ch_status == 'GP' || item.ch_status == 'RP' ) && item.a_receber > 0), (item) => { 
                    return parseInt(item.guias);
                });    

            } else if ( status == 'G' ) { 
                valor = _.sumBy(this.visao.situacao.filter(item => item.ch_status == 'GP' || item.ch_status == 'GC'), (item) => { 
                    return parseInt(item.guias);
                });    
            } else if ( status == 'R' ) { 
                valor = _.sumBy(this.visao.situacao.filter(item =>  (item.recebido && item.ch_status == 'GP') || item.ch_status == 'RC' || item.ch_status == 'RP'), (item) => { 
                    return parseInt(item.guias);
                });    
            } else { 
                valor = _.sumBy(this.visao.situacao.filter(item => item.ch_status == status), (item) => { 
                    return parseInt(item.guias);
                });
            }
            
            return valor ? valor : 0;
        },
        getDataByStatus (status) { 
            if( !this.visao )
                return "";

            let valor = _.minBy(this.visao.situacao.filter(item => item.ch_status == status), (item) => { 
                return item.dt_guia_criacao_1;
            });

            return valor ? valor.dt_guia_criacao_1 : "";
        },
        percentual(lista) { 
            const total = this.getValorTotalGuias(false);

            if ( !total )
                return "";

            return Math.round( ( this.getValorTotalByStatus(lista, false) / total ) * 100 ) + '%' ;

        },
        getValorTotalGuias(formatar = true, operadora = null) { 
            return this.getValorTotalByStatus (['DI', 'PR','PT', 'AF', 'PE', 'EF', 'FT', 'RC', 'RP', 'GT', 'GP', 'TS', 'PF'], formatar, operadora);
        },
        getValorTotalByStatus (status, formatar = true, operadora = null) { 
            if( !this.visao )
                return "";

            const valor = _.sumBy(
                this.visao.situacao.filter(item => !operadora || item.st_operadora == operadora), 
                (item) => { 
                    return status.indexOf(item.ch_status) >= 0 && item.valor ? parseFloat(item.valor) : 0;
                });

            return formatar ? this.$util.formatMoeda (valor) : valor;
        },
        load () { 

            let query = { q: [ 
                { 
                    name: 'guias.visao', 
                    id: 'visao',
                    parms: { 
                        ...this.filtros, 
                    }
                }, 

            ]};

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$store.commit('loading', true);
                                    
            this.axios.post('/aql?a=guias.visao', query, {
                    cancelToken: this.canceltoken.token
                })
                .then(res => { 
                    /*
                    if ( res.data.guias.status == 200 ) { 
                        this.guias = res.data.guias.data;
                    }
                    */

                    if ( res.data.visao.status == 200 ) { 
                        this.visao = res.data.visao.data;
                        this.guias = this.visao.pendencias;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
    },
    created() { 
        //this.filtros.inicio = this.$util.hoje().substr(0,7) + '-01';
        //this.filtros.fim = moment(this.filtros.inicio).endOf('month').format('YYYY-MM-DD');
    },
    mounted () { 
        this.$store.commit('setBreadcrumb', 
            [
                { name: "Faturamento", path: "/faturamento/visao"},
                { name: "Visão Geral", path: "/faturamento/visao"}
            ]);

        this.$store.commit('loading', true);

        this.load ();

        this.firstLoad = true;

    },
    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>

<style scoped>

.card-dash { 
    padding: 0px !important;
}
</style>